import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    maxWidth: 1200,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 1),
    },
  },
  card: {
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 8,
    },
  },
  header: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  title: {
    fontWeight: 700,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 0, 3),
    },
  },
  stepContent: {
    minHeight: 400,
    padding: theme.spacing(3, 2),
    [theme.breakpoints.down('sm')]: {
      minHeight: 300,
      padding: theme.spacing(2, 1),
    },
  },
  selectedCustomerCard: {
    marginTop: theme.spacing(3),
    backgroundColor: '#f8f9fa',
    borderRadius: 12,
  },
  searchBox: {
    marginBottom: theme.spacing(3),
  },
  productSelectBox: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    '& > *:first-child': {
      flex: 1,
      minWidth: 300,
    },
  },
  quantityField: {
    width: 120,
  },
  addButton: {
    height: 56,
    minWidth: 120,
    textTransform: 'none',
    fontWeight: 600,
  },
  tableContainer: {
    marginTop: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  boldText: {
    fontWeight: 600,
  },
  sellPrice: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  reviewCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    border: '1px solid #e0e0e0',
  },
  reviewTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  summaryCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    backgroundColor: '#f8f9fa',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
  },
  profitValue: {
    color: theme.palette.success.main,
    fontWeight: 700,
  },
  notesField: {
    marginTop: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  cancelButton: {
    textTransform: 'none',
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },
  navigationButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      order: 1,
      flexDirection: 'column',
      width: '100%',
    },
  },
  finishButton: {
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 4),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5, 2),
    },
  },
}));
